export default {
  'AdminUser': {
    collection: 'adminUsers',
    element: 'adminUser',
    label: 'name',
    enum: {
    }
  },
  'AdminUsersRole': {
    collection: 'adminUsersRoles',
    element: 'adminUsersRole',
    label: 'id',
    enum: {
    }
  },
  'Role': {
    collection: 'roles',
    element: 'role',
    label: 'name',
    enum: {
      kinds: [
        'super',
        'application',
        'custom',
      ],
    }
  },
  'Application': {
    collection: 'applications',
    element: 'application',
    label: 'name',
    enum: {
    }
  },
  'ActiveStorage::Attachment': {
    collection: 'activeStorage/attachments',
    element: 'activeStorage/attachment',
    label: 'name',
    enum: {
    }
  },
  'Banner': {
    collection: 'banners',
    element: 'banner',
    label: 'id',
    enum: {
      page_positions: [
        'book_club',
        'youth_camp',
      ],
      kinds: [
        'web_link',
        'image',
        'mp_link',
      ],
    }
  },
  'User': {
    collection: 'users',
    element: 'user',
    label: 'id',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'Profile': {
    collection: 'profiles',
    element: 'profile',
    label: 'name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'Student': {
    collection: 'students',
    element: 'student',
    label: 'name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'Member': {
    collection: 'members',
    element: 'member',
    label: 'name',
    enum: {
      genders: [
        'unknown',
        'male',
        'female',
      ],
    }
  },
  'InviteRelationship': {
    collection: 'inviteRelationships',
    element: 'inviteRelationship',
    label: 'name',
    enum: {
    }
  },
  'ActiveStorage::Blob': {
    collection: 'activeStorage/blobs',
    element: 'activeStorage/blob',
    label: 'id',
    enum: {
    }
  },
  'ActsAsTaggableOn::Tag': {
    collection: 'actsAsTaggableOn/tags',
    element: 'actsAsTaggableOn/tag',
    label: 'name',
    enum: {
    }
  },
  'Page': {
    collection: 'pages',
    element: 'page',
    label: 'title',
    enum: {
    }
  },
  'PresetPage': {
    collection: 'presetPages',
    element: 'presetPage',
    label: 'title',
    enum: {
    }
  },
  'StaticPage': {
    collection: 'staticPages',
    element: 'staticPage',
    label: 'title',
    enum: {
    }
  },
  'CustomPage': {
    collection: 'customPages',
    element: 'customPage',
    label: 'title',
    enum: {
    }
  },
  'HotWord': {
    collection: 'hotWords',
    element: 'hotWord',
    label: 'name',
    enum: {
    }
  },
  'Post': {
    collection: 'posts',
    element: 'post',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'CommentableCommentDatum': {
    collection: 'commentableCommentData',
    element: 'commentableCommentDatum',
    label: 'id',
    enum: {
    }
  },
  'Article': {
    collection: 'articles',
    element: 'article',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'CustomPostList': {
    collection: 'customPostLists',
    element: 'customPostList',
    label: 'title',
    enum: {
    }
  },
  'CustomPostListsPost': {
    collection: 'customPostListsPosts',
    element: 'customPostListsPost',
    label: 'id',
    enum: {
    }
  },
  'Comment': {
    collection: 'comments',
    element: 'comment',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'NormalComment': {
    collection: 'normalComments',
    element: 'normalComment',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'SpecialColumn': {
    collection: 'specialColumns',
    element: 'specialColumn',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'SpecialColumnArticleRelation': {
    collection: 'specialColumnArticleRelations',
    element: 'specialColumnArticleRelation',
    label: 'id',
    enum: {
    }
  },
  'SeekTruthWeekly': {
    collection: 'seekTruthWeeklies',
    element: 'seekTruthWeekly',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'SeekTruthVideo': {
    collection: 'seekTruthVideos',
    element: 'seekTruthVideo',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'BookClub': {
    collection: 'bookClubs',
    element: 'bookClub',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'BookList': {
    collection: 'bookLists',
    element: 'bookList',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'Podcast': {
    collection: 'podcasts',
    element: 'podcast',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'ExperienceComment': {
    collection: 'experienceComments',
    element: 'experienceComment',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
  'ApplyRecord': {
    collection: 'applyRecords',
    element: 'applyRecord',
    label: 'id',
    enum: {
      states: [
        'applied',
        'paid',
        'refund_audit',
        'refunding',
        'refunded',
      ],
    }
  },
  'Reason': {
    collection: 'reasons',
    element: 'reason',
    label: 'name',
    enum: {
      kinds: [
        'refund',
      ],
    }
  },
  'YouthCamp': {
    collection: 'youthCamps',
    element: 'youthCamp',
    label: 'title',
    enum: {
      content_types: [
        'richtext',
        'markdown',
      ],
    }
  },
  'PriceTypeTemplate': {
    collection: 'priceTypeTemplates',
    element: 'priceTypeTemplate',
    label: 'name',
    enum: {
    }
  },
  'PriceType': {
    collection: 'priceTypes',
    element: 'priceType',
    label: 'name',
    enum: {
    }
  },
  'InvoiceApplyRecord': {
    collection: 'invoiceApplyRecords',
    element: 'invoiceApplyRecord',
    label: 'title',
    enum: {
      states: [
        'pending',
        'processing',
        'processed',
      ],
      invoice_types: [
        'vat_general_invoice',
        'vat_special_invoice',
        'general_invoice',
      ],
      title_types: [
        'individual',
        'company',
      ],
    }
  },
  'YouthCampExperienceComment': {
    collection: 'youthCampExperienceComments',
    element: 'youthCampExperienceComment',
    label: 'id',
    enum: {
      states: [
        'pending',
        'approved',
        'rejected',
      ],
    }
  },
}
